{
  "about": "Realmery's built-in Atlas icons, for Realmery Web. Written by BuiltinIconsFixtureTest. Each is path data in a 24 x 24 box, filled in one colour; keys never change once shipped. \"geometry\" checks the web's port of MapGeometry.",
  "size": 24.0,
  "icons": [
    {
      "key": "capital",
      "ref": "lf:capital",
      "name": "Capital",
      "group": "Settlements",
      "path": "M3 18L3 7.5L7.5 12L12 4.5L16.5 12L21 7.5L21 18ZM3 19L21 19L21 21.5L3 21.5ZM1.7 6.5A1.3 1.3 0 1 1 4.3 6.5A1.3 1.3 0 1 1 1.7 6.5ZM10.5 3.5A1.5 1.5 0 1 1 13.5 3.5A1.5 1.5 0 1 1 10.5 3.5ZM19.7 6.5A1.3 1.3 0 1 1 22.3 6.5A1.3 1.3 0 1 1 19.7 6.5Z",
      "evenOdd": false
    },
    {
      "key": "city",
      "ref": "lf:city",
      "name": "City",
      "group": "Settlements",
      "path": "M2.5 10L8 10L8 21L2.5 21ZM9 3.5L15 3.5L15 21L9 21ZM16 8L21.5 8L21.5 21L16 21ZM10.5 7.1L11.7 7.1L11.7 5.5L10.5 5.5ZM12.3 7.1L13.5 7.1L13.5 5.5L12.3 5.5ZM10.5 10.6L11.7 10.6L11.7 9L10.5 9ZM12.3 10.6L13.5 10.6L13.5 9L12.3 9ZM10.5 14.1L11.7 14.1L11.7 12.5L10.5 12.5ZM12.3 14.1L13.5 14.1L13.5 12.5L12.3 12.5ZM4 13.4L6.5 13.4L6.5 12L4 12ZM17.5 11.9L20 11.9L20 10.5L17.5 10.5ZM17.5 15.4L20 15.4L20 14L17.5 14Z",
      "evenOdd": false
    },
    {
      "key": "town",
      "ref": "lf:town",
      "name": "Town",
      "group": "Settlements",
      "path": "M1.5 12L6.5 7L11.5 12L11.5 21L1.5 21ZM10.5 9L16.5 3L22.5 9L22.5 21L10.5 21ZM5 21L8 21L8 16L5 16ZM15 21L18 21L18 15L15 15ZM15 12.5L18 12.5L18 10L15 10Z",
      "evenOdd": false
    },
    {
      "key": "village",
      "ref": "lf:village",
      "name": "Village",
      "group": "Settlements",
      "path": "M3 11.5L12 3.5L21 11.5L19 11.5L19 21L5 21L5 11.5ZM15.5 4.5L17.7 4.5L17.7 9.5L15.5 9.5ZM14 21L14 16L13.93 15.48L13.73 15L13.41 14.59L13 14.27L12.52 14.07L12 14L11.48 14.07L11 14.27L10.59 14.59L10.27 15L10.07 15.48L10 16L10 21ZM6.5 15.5L9 15.5L9 13L6.5 13Z",
      "evenOdd": false
    },
    {
      "key": "hamlet",
      "ref": "lf:hamlet",
      "name": "Hamlet",
      "group": "Settlements",
      "path": "M2 14L12 4L22 14ZM5 13.5L19 13.5L19 21L5 21ZM13.8 21L13.8 17.3L13.74 16.83L13.56 16.4L13.27 16.03L12.9 15.74L12.47 15.56L12 15.5L11.53 15.56L11.1 15.74L10.73 16.03L10.44 16.4L10.26 16.83L10.2 17.3L10.2 21Z",
      "evenOdd": false
    },
    {
      "key": "camp",
      "ref": "lf:camp",
      "name": "Camp",
      "group": "Settlements",
      "path": "M2 20.5L12 4.5L22 20.5ZM12 11L9 20.5L15 20.5ZM11.54 4.12L14.04 1.12L14.96 1.88L12.46 4.88ZM1 20.5L23 20.5L23 22L1 22Z",
      "evenOdd": false
    },
    {
      "key": "port-town",
      "ref": "lf:port-town",
      "name": "Harbor town",
      "group": "Settlements",
      "path": "M3 10L8 5L13 10L13 16L3 16ZM12 8L16.5 4L21 8L21 16L12 16ZM6.5 16L9.5 16L9.5 12L6.5 12ZM15 14L18 14L18 11L15 11ZM1.5 17.5L22.5 17.5L22.5 19L1.5 19ZM3.09 19.94L3.32 19.45L3.63 19.01L4.01 18.63L4.45 18.32L4.94 18.09L5.46 17.95L6 17.9L6.54 17.95L7.06 18.09L7.55 18.32L7.99 18.63L8.37 19.01L8.68 19.45L8.91 19.94L7.79 20.35L7.65 20.05L7.46 19.78L7.22 19.54L6.95 19.35L6.65 19.21L6.33 19.13L6 19.1L5.67 19.13L5.35 19.21L5.05 19.35L4.78 19.54L4.54 19.78L4.35 20.05L4.21 20.35ZM9.09 19.94L9.32 19.45L9.63 19.01L10.01 18.63L10.45 18.32L10.94 18.09L11.46 17.95L12 17.9L12.54 17.95L13.06 18.09L13.55 18.32L13.99 18.63L14.37 19.01L14.68 19.45L14.91 19.94L13.79 20.35L13.65 20.05L13.46 19.78L13.22 19.54L12.95 19.35L12.65 19.21L12.33 19.13L12 19.1L11.67 19.13L11.35 19.21L11.05 19.35L10.78 19.54L10.54 19.78L10.35 20.05L10.21 20.35ZM15.09 19.94L15.32 19.45L15.63 19.01L16.01 18.63L16.45 18.32L16.94 18.09L17.46 17.95L18 17.9L18.54 17.95L19.06 18.09L19.55 18.32L19.99 18.63L20.37 19.01L20.68 19.45L20.91 19.94L19.79 20.35L19.65 20.05L19.46 19.78L19.22 19.54L18.95 19.35L18.65 19.21L18.33 19.13L18 19.1L17.67 19.13L17.35 19.21L17.05 19.35L16.78 19.54L16.54 19.78L16.35 20.05L16.21 20.35Z",
      "evenOdd": false
    },
    {
      "key": "castle",
      "ref": "lf:castle",
      "name": "Castle",
      "group": "Fortifications",
      "path": "M2.5 7L8 7L8 21L2.5 21ZM16 7L21.5 7L21.5 21L16 21ZM8 11L16 11L16 21L8 21ZM2.5 4.5L4.1 4.5L4.1 7.1L2.5 7.1ZM6.4 4.5L8 4.5L8 7.1L6.4 7.1ZM16 4.5L17.6 4.5L17.6 7.1L16 7.1ZM19.9 4.5L21.5 4.5L21.5 7.1L19.9 7.1ZM8 9L9.6 9L9.6 11.1L8 11.1ZM11.2 9L12.8 9L12.8 11.1L11.2 11.1ZM14.4 9L16 9L16 11.1L14.4 11.1ZM14 21L14 16.5L13.93 15.98L13.73 15.5L13.41 15.09L13 14.77L12.52 14.57L12 14.5L11.48 14.57L11 14.77L10.59 15.09L10.27 15.5L10.07 15.98L10 16.5L10 21ZM4.5 13L6 13L6 10L4.5 10ZM18 13L19.5 13L19.5 10L18 10Z",
      "evenOdd": false
    },
    {
      "key": "keep",
      "ref": "lf:keep",
      "name": "Keep",
      "group": "Fortifications",
      "path": "M6 7L18 7L18 21L6 21ZM6 3.5L8.4 3.5L8.4 7.1L6 7.1ZM10.8 3.5L13.2 3.5L13.2 7.1L10.8 7.1ZM15.6 3.5L18 3.5L18 7.1L15.6 7.1ZM14.2 21L14.2 16.2L14.13 15.63L13.91 15.1L13.56 14.64L13.1 14.29L12.57 14.07L12 14L11.43 14.07L10.9 14.29L10.44 14.64L10.09 15.1L9.87 15.63L9.8 16.2L9.8 21ZM11.2 12L12.8 12L12.8 9L11.2 9Z",
      "evenOdd": false
    },
    {
      "key": "tower",
      "ref": "lf:tower",
      "name": "Tower",
      "group": "Fortifications",
      "path": "M7.5 8L12 1.5L16.5 8ZM9 8L15 8L16 21L8 21ZM11.3 13.5L12.7 13.5L12.7 10.5L11.3 10.5ZM13.5 21L13.5 17.5L13.45 17.11L13.3 16.75L13.06 16.44L12.75 16.2L12.39 16.05L12 16L11.61 16.05L11.25 16.2L10.94 16.44L10.7 16.75L10.55 17.11L10.5 17.5L10.5 21Z",
      "evenOdd": false
    },
    {
      "key": "walls",
      "ref": "lf:walls",
      "name": "Walls",
      "group": "Fortifications",
      "path": "M2 10L22 10L22 21L2 21ZM2 7L4.6 7L4.6 10L2 10ZM6.35 7L8.95 7L8.95 10L6.35 10ZM10.7 7L13.3 7L13.3 10L10.7 10ZM15.05 7L17.65 7L17.65 10L15.05 10ZM19.4 7L22 7L22 10L19.4 10ZM2 15.3L22 15.3L22 14.5L2 14.5ZM14.5 21L14.5 17.8L14.41 17.15L14.17 16.55L13.77 16.03L13.25 15.63L12.65 15.39L12 15.3L11.35 15.39L10.75 15.63L10.23 16.03L9.83 16.55L9.59 17.15L9.5 17.8L9.5 21Z",
      "evenOdd": false
    },
    {
      "key": "gate",
      "ref": "lf:gate",
      "name": "Gate",
      "group": "Fortifications",
      "path": "M3 6L21 6L21 21L3 21ZM3 3.5L5.5 3.5L5.5 6.1L3 6.1ZM7.5 3.5L10 3.5L10 6.1L7.5 6.1ZM14 3.5L16.5 3.5L16.5 6.1L14 6.1ZM18.5 3.5L21 3.5L21 6.1L18.5 6.1ZM17 21L17 14L16.83 12.71L16.33 11.5L15.54 10.46L14.5 9.67L13.29 9.17L12 9L10.71 9.17L9.5 9.67L8.46 10.46L7.67 11.5L7.17 12.71L7 14L7 21ZM10 13L10 21L9 21L9 13ZM12.5 11L12.5 21L11.5 21L11.5 11ZM15 13L15 21L14 21L14 13ZM7.5 15.5L16.5 15.5L16.5 16.5L7.5 16.5Z",
      "evenOdd": false
    },
    {
      "key": "fort",
      "ref": "lf:fort",
      "name": "Fort",
      "group": "Fortifications",
      "path": "M2.2 21L2.2 8.5L3.6 6L5 8.5L5 21ZM5.6 21L5.6 8.5L7 6L8.4 8.5L8.4 21ZM9 21L9 8.5L10.4 6L11.8 8.5L11.8 21ZM12.4 21L12.4 8.5L13.8 6L15.2 8.5L15.2 21ZM15.8 21L15.8 8.5L17.2 6L18.6 8.5L18.6 21ZM19.2 21L19.2 8.5L20.6 6L22 8.5L22 21ZM2 12.5L22.5 12.5L22.5 11.5L2 11.5ZM2 18L22.5 18L22.5 17L2 17Z",
      "evenOdd": false
    },
    {
      "key": "temple",
      "ref": "lf:temple",
      "name": "Temple",
      "group": "Faith and magic",
      "path": "M2 8.5L12 3L22 8.5ZM3 9L21 9L21 10.8L3 10.8ZM2 19.5L22 19.5L22 21.5L2 21.5ZM4.3 11.5L6.5 11.5L6.5 19L4.3 19ZM8.7 11.5L10.9 11.5L10.9 19L8.7 19ZM13.1 11.5L15.3 11.5L15.3 19L13.1 19ZM17.5 11.5L19.7 11.5L19.7 19L17.5 19Z",
      "evenOdd": false
    },
    {
      "key": "shrine",
      "ref": "lf:shrine",
      "name": "Shrine",
      "group": "Faith and magic",
      "path": "M4 9.5L12 3.5L20 9.5ZM6.5 9.5L17.5 9.5L17.5 11L6.5 11ZM8 11L9.5 11L9.5 18L8 18ZM14.5 11L16 11L16 18L14.5 18ZM5 18L19 18L19 21L5 21ZM10.2 14A1.8 1.8 0 1 1 13.8 14A1.8 1.8 0 1 1 10.2 14Z",
      "evenOdd": false
    },
    {
      "key": "monastery",
      "ref": "lf:monastery",
      "name": "Monastery",
      "group": "Faith and magic",
      "path": "M2 13L9 7L16 13L16 21L2 21ZM15 8L21 8L21 21L15 21ZM14.5 8L18 4L21.5 8ZM17.3 0.8L18.7 0.8L18.7 4.4L17.3 4.4ZM16.2 1.7L19.8 1.7L19.8 2.9L16.2 2.9ZM10.7 21L10.7 17.2L10.64 16.76L10.47 16.35L10.2 16L9.85 15.73L9.44 15.56L9 15.5L8.56 15.56L8.15 15.73L7.8 16L7.53 16.35L7.36 16.76L7.3 17.2L7.3 21ZM18.8 14L18.8 11.8L18.77 11.59L18.69 11.4L18.57 11.23L18.4 11.11L18.21 11.03L18 11L17.79 11.03L17.6 11.11L17.43 11.23L17.31 11.4L17.23 11.59L17.2 11.8L17.2 14Z",
      "evenOdd": false
    },
    {
      "key": "stones",
      "ref": "lf:stones",
      "name": "Standing stones",
      "group": "Faith and magic",
      "path": "M3 20L3.7 9.5L5.5 8L7.5 9L8 20ZM9.7 20L10.2 5L12.2 3.8L14 4.8L14.4 20ZM16 20L16.6 10L18.6 9L20.5 10.5L21 20ZM1.5 20L22.5 20L22.5 21.8L1.5 21.8Z",
      "evenOdd": false
    },
    {
      "key": "portal",
      "ref": "lf:portal",
      "name": "Portal",
      "group": "Faith and magic",
      "path": "M2.5 12A9.5 9.5 0 1 1 21.5 12A9.5 9.5 0 1 1 2.5 12ZM5.5 12A6.5 6.5 0 1 0 18.5 12A6.5 6.5 0 1 0 5.5 12ZM7.3 12L7.37 11.18L7.58 10.39L7.93 9.65L8.4 8.98L8.98 8.4L9.65 7.93L10.39 7.58L11.18 7.37L12 7.3L12.82 7.37L13.61 7.58L14.35 7.93L15.02 8.4L15.6 8.98L16.07 9.65L16.42 10.39L16.63 11.18L16.7 12L16.63 12.82L16.42 13.61L16.07 14.35L15.6 15.02L15.02 15.6L14.35 16.07L13.65 14.86L14.12 14.53L14.53 14.12L14.86 13.65L15.1 13.13L15.25 12.57L15.3 12L15.25 11.43L15.1 10.87L14.86 10.35L14.53 9.88L14.12 9.47L13.65 9.14L13.13 8.9L12.57 8.75L12 8.7L11.43 8.75L10.87 8.9L10.35 9.14L9.88 9.47L9.47 9.88L9.14 10.35L8.9 10.87L8.75 11.43L8.7 12ZM10.6 12A1.4 1.4 0 1 1 13.4 12A1.4 1.4 0 1 1 10.6 12Z",
      "evenOdd": false
    },
    {
      "key": "arcane",
      "ref": "lf:arcane",
      "name": "Arcane site",
      "group": "Faith and magic",
      "path": "M12 2L13.84 10.16L22 12L13.84 13.84L12 22L10.16 13.84L2 12L10.16 10.16ZM19 1.8L19.64 4.36L22.2 5L19.64 5.64L19 8.2L18.36 5.64L15.8 5L18.36 4.36ZM5 16.4L5.57 18.43L7.6 19L5.57 19.57L5 21.6L4.43 19.57L2.4 19L4.43 18.43Z",
      "evenOdd": false
    },
    {
      "key": "port",
      "ref": "lf:port",
      "name": "Port",
      "group": "Travel and trade",
      "path": "M9.4 4.8A2.6 2.6 0 1 1 14.6 4.8A2.6 2.6 0 1 1 9.4 4.8ZM10.7 4.8A1.3 1.3 0 1 0 13.3 4.8A1.3 1.3 0 1 0 10.7 4.8ZM13 7.2L13 20.5L11 20.5L11 7.2ZM7.5 8.6L16.5 8.6L16.5 10.4L7.5 10.4ZM19.99 15.91L19.36 17.25L18.51 18.46L17.46 19.51L16.25 20.36L14.91 20.99L13.48 21.37L12 21.5L10.52 21.37L9.09 20.99L7.75 20.36L6.54 19.51L5.49 18.46L4.64 17.25L4.01 15.91L5.89 15.22L6.37 16.25L7.02 17.18L7.82 17.98L8.75 18.63L9.78 19.11L10.87 19.4L12 19.5L13.13 19.4L14.22 19.11L15.25 18.63L16.18 17.98L16.98 17.18L17.63 16.25L18.11 15.22ZM18.9 14L21.5 12.5L20.8 16.8ZM3.2 16.8L2.5 12.5L5.1 14Z",
      "evenOdd": false
    },
    {
      "key": "ship",
      "ref": "lf:ship",
      "name": "Ship",
      "group": "Travel and trade",
      "path": "M1.5 15L22.5 15L19.5 20.5L4.5 20.5ZM11.3 2.5L12.7 2.5L12.7 15L11.3 15ZM13 3.5L20.5 13.5L13 13.5ZM11 13.5L4.5 13.5L11 6Z",
      "evenOdd": false
    },
    {
      "key": "bridge",
      "ref": "lf:bridge",
      "name": "Bridge",
      "group": "Travel and trade",
      "path": "M1 9.5L23 9.5L23 12.3L1 12.3ZM1 12L23 12L23 20.5L1 20.5ZM18.5 20.5L18.5 20.5L18.28 18.82L17.63 17.25L16.6 15.9L15.25 14.87L13.68 14.22L12 14L10.32 14.22L8.75 14.87L7.4 15.9L6.37 17.25L5.72 18.82L5.5 20.5L5.5 20.5ZM2 5.5L3.3 5.5L3.3 9.5L2 9.5ZM7 5.5L8.3 5.5L8.3 9.5L7 9.5ZM12 5.5L13.3 5.5L13.3 9.5L12 9.5ZM17 5.5L18.3 5.5L18.3 9.5L17 9.5ZM21 5.5L22.3 5.5L22.3 9.5L21 9.5ZM1.5 5.5L22.5 5.5L22.5 6.7L1.5 6.7Z",
      "evenOdd": false
    },
    {
      "key": "signpost",
      "ref": "lf:signpost",
      "name": "Signpost",
      "group": "Travel and trade",
      "path": "M11 3L13 3L13 21.5L11 21.5ZM13 4.5L19.5 4.5L22 7.2L19.5 10L13 10ZM11 17L4.5 17L2 14.2L4.5 11.5L11 11.5ZM8 20.5L16 20.5L16 22L8 22Z",
      "evenOdd": false
    },
    {
      "key": "inn",
      "ref": "lf:inn",
      "name": "Inn",
      "group": "Travel and trade",
      "path": "M4.5 8L16 8L16 21L4.5 21ZM16 10L20.5 10L20.5 18L16 18ZM16 16.2L18.6 16.2L18.6 11.8L16 11.8ZM4.3 7.5A2.2 2.2 0 1 1 8.7 7.5A2.2 2.2 0 1 1 4.3 7.5ZM7.6 6.4A2.6 2.6 0 1 1 12.8 6.4A2.6 2.6 0 1 1 7.6 6.4ZM11.7 7.5A2.2 2.2 0 1 1 16.1 7.5A2.2 2.2 0 1 1 11.7 7.5ZM7.2 18.5L8.4 18.5L8.4 11L7.2 11ZM12.1 18.5L13.3 18.5L13.3 11L12.1 11Z",
      "evenOdd": false
    },
    {
      "key": "market",
      "ref": "lf:market",
      "name": "Market",
      "group": "Travel and trade",
      "path": "M2.5 4L21.5 4L21.5 8L2.5 8ZM2.5 8L6.3 8L4.4 10.5ZM6.3 8L10.1 8L8.2 10.5ZM10.1 8L13.9 8L12 10.5ZM13.9 8L17.7 8L15.8 10.5ZM17.7 8L21.5 8L19.6 10.5ZM3.5 8L5 8L5 21L3.5 21ZM19 8L20.5 8L20.5 21L19 21ZM5 14.5L19 14.5L19 21L5 21ZM7.2 13.2A1.3 1.3 0 1 1 9.8 13.2A1.3 1.3 0 1 1 7.2 13.2ZM10.3 12.8A1.7 1.7 0 1 1 13.7 12.8A1.7 1.7 0 1 1 10.3 12.8ZM14.2 13.2A1.3 1.3 0 1 1 16.8 13.2A1.3 1.3 0 1 1 14.2 13.2Z",
      "evenOdd": false
    },
    {
      "key": "mine",
      "ref": "lf:mine",
      "name": "Mine",
      "group": "Travel and trade",
      "path": "M3.49 20.18L14.49 6.68L16.51 8.32L5.51 21.82ZM5.5 5.5L11 2.3L16.5 2.6L22.5 7.5L20.6 10L16.3 6.9L11.8 6.6L7 8.2Z",
      "evenOdd": false
    },
    {
      "key": "farm",
      "ref": "lf:farm",
      "name": "Farm",
      "group": "Travel and trade",
      "path": "M3 10.5L12 4L21 10.5L21 21L3 21ZM8.5 21L15.5 21L15.5 13.5L8.5 13.5ZM9.17 13.46L15.57 20.46L14.83 21.14L8.43 14.14ZM15.57 14.14L9.17 21.14L8.43 20.46L14.83 13.46ZM10.5 10.5L13.5 10.5L13.5 8L10.5 8Z",
      "evenOdd": false
    },
    {
      "key": "compass",
      "ref": "lf:compass",
      "name": "Crossroads",
      "group": "Travel and trade",
      "path": "M2 12A10 10 0 1 1 22 12A10 10 0 1 1 2 12ZM3.6 12A8.4 8.4 0 1 0 20.4 12A8.4 8.4 0 1 0 3.6 12ZM12 3.5L14 12L12 20.5L10 12ZM3.5 12L12 10L20.5 12L12 14ZM10.8 12A1.2 1.2 0 1 0 13.2 12A1.2 1.2 0 1 0 10.8 12Z",
      "evenOdd": false
    },
    {
      "key": "mountain",
      "ref": "lf:mountain",
      "name": "Mountain",
      "group": "Nature",
      "path": "M1.5 20.5L8.5 7.5L11.5 12L15.5 5L22.5 20.5ZM15.5 5L13.8 8.8L15.3 8L16.5 9.5L17.2 8Z",
      "evenOdd": false
    },
    {
      "key": "volcano",
      "ref": "lf:volcano",
      "name": "Volcano",
      "group": "Nature",
      "path": "M1.5 20.5L8 10L10.5 11.5L13.5 10L16 11.5L22.5 20.5ZM8.9 6.5A1.6 1.6 0 1 1 12.1 6.5A1.6 1.6 0 1 1 8.9 6.5ZM11.1 4.5A2.1 2.1 0 1 1 15.3 4.5A2.1 2.1 0 1 1 11.1 4.5ZM14.6 6.8A1.4 1.4 0 1 1 17.4 6.8A1.4 1.4 0 1 1 14.6 6.8ZM11.5 12L10 16L12.3 14.5L13.8 17.5L14 12.5Z",
      "evenOdd": false
    },
    {
      "key": "forest",
      "ref": "lf:forest",
      "name": "Forest",
      "group": "Nature",
      "path": "M7 2L11 8.5L9 8.5L12 13.5L9.5 13.5L12.5 18L1.5 18L4.5 13.5L2 13.5L5 8.5L3 8.5ZM6.1 18L7.9 18L7.9 21L6.1 21ZM16.5 5L20 10.5L18.3 10.5L21 14.5L18.8 14.5L22.5 19L10.5 19L14.2 14.5L12 14.5L14.7 10.5L13 10.5ZM15.6 19L17.4 19L17.4 21.5L15.6 21.5Z",
      "evenOdd": false
    },
    {
      "key": "cave",
      "ref": "lf:cave",
      "name": "Cave",
      "group": "Nature",
      "path": "M1 21L3.5 13L8 7L12 5.5L16 7L20.5 13L23 21ZM16 21L16 16.5L15.86 15.46L15.46 14.5L14.83 13.67L14 13.04L13.04 12.64L12 12.5L10.96 12.64L10 13.04L9.17 13.67L8.54 14.5L8.14 15.46L8 16.5L8 21Z",
      "evenOdd": false
    },
    {
      "key": "lake",
      "ref": "lf:lake",
      "name": "Lake",
      "group": "Nature",
      "path": "M2 13A10 6 0 1 1 22 13A10 6 0 1 1 2 13ZM6 11.5L10.5 11.5L10.5 10.5L6 10.5ZM11.5 15L17.5 15L17.5 14L11.5 14ZM7.5 17.5L11 17.5L11 16.5L7.5 16.5Z",
      "evenOdd": false
    },
    {
      "key": "spring",
      "ref": "lf:spring",
      "name": "Spring",
      "group": "Nature",
      "path": "M6 15A6 6 0 1 1 18 15A6 6 0 1 1 6 15ZM12 2.5L17.3 12.5L6.7 12.5ZM10.8 16.5L10.8 14.5L10.77 14.24L10.67 14L10.51 13.79L10.3 13.63L10.06 13.53L9.8 13.5L9.54 13.53L9.3 13.63L9.09 13.79L8.93 14L8.83 14.24L8.8 14.5L8.8 16.5Z",
      "evenOdd": false
    },
    {
      "key": "oasis",
      "ref": "lf:oasis",
      "name": "Oasis",
      "group": "Nature",
      "path": "M11.2 19.5L12 10.5L13.6 10.5L13.2 19.5ZM12.8 10L18 6.5L22 9.5L17.5 8.5ZM8 8.2L3.5 9L8 6.5L12.8 10ZM12.8 10L15.5 3.5L19.5 3.5L15.8 5.5ZM9.7 5.5L6 4L10 3.5L12.8 10ZM3 20.5A9 1.8 0 1 1 21 20.5A9 1.8 0 1 1 3 20.5Z",
      "evenOdd": false
    },
    {
      "key": "island",
      "ref": "lf:island",
      "name": "Island",
      "group": "Nature",
      "path": "M4.5 18L4.5 20.5L4.76 18.56L5.5 16.75L6.7 15.2L8.25 14L10.06 13.26L12 13L13.94 13.26L15.75 14L17.3 15.2L18.5 16.75L19.24 18.56L19.5 20.5L19.5 18ZM1.5 18.5L22.5 18.5L22.5 19.9L1.5 19.9ZM2.99 21.91L3.23 21.4L3.55 20.94L3.94 20.55L4.4 20.23L4.91 19.99L5.44 19.85L6 19.8L6.56 19.85L7.09 19.99L7.6 20.23L8.06 20.55L8.45 20.94L8.77 21.4L9.01 21.91L7.88 22.32L7.73 22L7.53 21.71L7.29 21.47L7 21.27L6.68 21.12L6.35 21.03L6 21L5.65 21.03L5.32 21.12L5 21.27L4.71 21.47L4.47 21.71L4.27 22L4.12 22.32ZM8.99 21.91L9.23 21.4L9.55 20.94L9.94 20.55L10.4 20.23L10.91 19.99L11.44 19.85L12 19.8L12.56 19.85L13.09 19.99L13.6 20.23L14.06 20.55L14.45 20.94L14.77 21.4L15.01 21.91L13.88 22.32L13.73 22L13.53 21.71L13.29 21.47L13 21.27L12.68 21.12L12.35 21.03L12 21L11.65 21.03L11.32 21.12L11 21.27L10.71 21.47L10.47 21.71L10.27 22L10.12 22.32ZM14.99 21.91L15.23 21.4L15.55 20.94L15.94 20.55L16.4 20.23L16.91 19.99L17.44 19.85L18 19.8L18.56 19.85L19.09 19.99L19.6 20.23L20.06 20.55L20.45 20.94L20.77 21.4L21.01 21.91L19.88 22.32L19.73 22L19.53 21.71L19.29 21.47L19 21.27L18.68 21.12L18.35 21.03L18 21L17.65 21.03L17.32 21.12L17 21.27L16.71 21.47L16.47 21.71L16.27 22L16.12 22.32ZM11.4 13.5L12 5.5L13.2 5.5L12.9 13.5ZM12.6 5.5L17 3L19.5 5.5L16 4.8ZM8.5 4.6L5 5.2L8 3L12.6 5.5Z",
      "evenOdd": false
    },
    {
      "key": "dungeon",
      "ref": "lf:dungeon",
      "name": "Dungeon",
      "group": "Danger",
      "path": "M3.5 3.5L20.5 3.5L20.5 21L3.5 21ZM17.5 21L17.5 12.5L17.31 11.08L16.76 9.75L15.89 8.61L14.75 7.74L13.42 7.19L12 7L10.58 7.19L9.25 7.74L8.11 8.61L7.24 9.75L6.69 11.08L6.5 12.5L6.5 21ZM9 10L10.3 10L10.3 21L9 21ZM11.35 8.5L12.65 8.5L12.65 21L11.35 21ZM13.7 10L15 10L15 21L13.7 21ZM7.5 14L16.5 14L16.5 15.2L7.5 15.2Z",
      "evenOdd": false
    },
    {
      "key": "lair",
      "ref": "lf:lair",
      "name": "Lair",
      "group": "Danger",
      "path": "M4 4.5L5.6 3.8L10.4 19.5L8.8 20.5ZM9.8 3.2L11.4 2.6L14.8 19.5L13.2 20.5ZM15.6 4.2L17.2 3.6L19.6 18.5L18 19.3Z",
      "evenOdd": false
    },
    {
      "key": "battle",
      "ref": "lf:battle",
      "name": "Battle site",
      "group": "Danger",
      "path": "M16.22 13.54L13.54 16.22L3 3ZM11.13 17.21L17.21 11.13L18.63 12.55L12.55 18.63ZM15.59 14.17L19.22 17.8L17.8 19.22L14.17 15.59ZM17.7 19.5A1.8 1.8 0 1 1 21.3 19.5A1.8 1.8 0 1 1 17.7 19.5ZM10.46 16.22L7.78 13.54L21 3ZM6.79 11.13L12.87 17.21L11.45 18.63L5.37 12.55ZM9.83 15.59L6.2 19.22L4.78 17.8L8.41 14.17ZM2.7 19.5A1.8 1.8 0 1 1 6.3 19.5A1.8 1.8 0 1 1 2.7 19.5Z",
      "evenOdd": false
    },
    {
      "key": "skull",
      "ref": "lf:skull",
      "name": "Skull",
      "group": "Danger",
      "path": "M4 10A8 8 0 1 1 20 10A8 8 0 1 1 4 10ZM7.5 14L16.5 14L16.5 20.5L7.5 20.5ZM6.6 10.5A2.2 2.2 0 1 0 11 10.5A2.2 2.2 0 1 0 6.6 10.5ZM13 10.5A2.2 2.2 0 1 0 17.4 10.5A2.2 2.2 0 1 0 13 10.5ZM12 12.8L10.8 15.2L13.2 15.2ZM9.6 20.5L10.6 20.5L10.6 17.3L9.6 17.3ZM11.5 20.5L12.5 20.5L12.5 17.3L11.5 17.3ZM13.4 20.5L14.4 20.5L14.4 17.3L13.4 17.3Z",
      "evenOdd": false
    },
    {
      "key": "ruins",
      "ref": "lf:ruins",
      "name": "Ruins",
      "group": "Danger",
      "path": "M3.5 19L3.5 7L5 5.5L6.2 7.2L7.5 6L7.5 19ZM10 19L10 11L11.2 12.2L12.6 10.3L14 11.5L14 19ZM16.5 19L16.5 8.5L18 7.5L19.2 9.5L20.5 8.2L20.5 19ZM2 19L22 19L22 21.5L2 21.5ZM8.5 18.8L9.5 15.5L13.8 16.5L12.8 18.8Z",
      "evenOdd": false
    },
    {
      "key": "graveyard",
      "ref": "lf:graveyard",
      "name": "Graveyard",
      "group": "Danger",
      "path": "M6 19.5L6 9.5L6.2 7.95L6.8 6.5L7.76 5.26L9 4.3L10.45 3.7L12 3.5L13.55 3.7L15 4.3L16.24 5.26L17.2 6.5L17.8 7.95L18 9.5L18 19.5ZM3 19.5L21 19.5L21 21.5L3 21.5ZM11.1 15.5L12.9 15.5L12.9 6.5L11.1 6.5ZM8.8 10.5L11.1 10.5L11.1 8.8L8.8 8.8ZM12.9 10.5L15.2 10.5L15.2 8.8L12.9 8.8Z",
      "evenOdd": false
    },
    {
      "key": "trap",
      "ref": "lf:trap",
      "name": "Trap",
      "group": "Danger",
      "path": "M2 19L4 6L6 19ZM6 19L8 9.5L10 19ZM10 19L12 6L14 19ZM14 19L16 9.5L18 19ZM18 19L20 6L22 19ZM1.5 19L22.5 19L22.5 21.5L1.5 21.5Z",
      "evenOdd": false
    },
    {
      "key": "hazard",
      "ref": "lf:hazard",
      "name": "Hazard",
      "group": "Danger",
      "path": "M12 2.5L22.5 20.5L1.5 20.5ZM11.4 14.5L12.6 14.5L13 8.5L11 8.5ZM10.8 17.2A1.2 1.2 0 1 0 13.2 17.2A1.2 1.2 0 1 0 10.8 17.2Z",
      "evenOdd": false
    },
    {
      "key": "quest",
      "ref": "lf:quest",
      "name": "Quest",
      "group": "Story",
      "path": "M9.8 2.5L14.2 2.5L13.2 15L10.8 15ZM9.8 19A2.2 2.2 0 1 1 14.2 19A2.2 2.2 0 1 1 9.8 19Z",
      "evenOdd": false
    },
    {
      "key": "treasure",
      "ref": "lf:treasure",
      "name": "Treasure",
      "group": "Story",
      "path": "M3 11.5L3 14L3.31 11.67L4.21 9.5L5.64 7.64L7.5 6.21L9.67 5.31L12 5L14.33 5.31L16.5 6.21L18.36 7.64L19.79 9.5L20.69 11.67L21 14L21 11.5ZM3 12.2L21 12.2L21 21L3 21ZM10.8 16.8L13.2 16.8L13.2 13.5L10.8 13.5ZM6 11.5L7.3 11.5L7.3 7.5L6 7.5ZM16.7 11.5L18 11.5L18 7.5L16.7 7.5Z",
      "evenOdd": false
    },
    {
      "key": "secret",
      "ref": "lf:secret",
      "name": "Secret",
      "group": "Story",
      "path": "M2.5 12A9.5 9.5 0 1 1 21.5 12A9.5 9.5 0 1 1 2.5 12ZM9.4 9.2A2.6 2.6 0 1 0 14.6 9.2A2.6 2.6 0 1 0 9.4 9.2ZM9.8 17.5L14.2 17.5L13.3 11.9L10.7 11.9Z",
      "evenOdd": false
    },
    {
      "key": "clue",
      "ref": "lf:clue",
      "name": "Clue",
      "group": "Story",
      "path": "M3 10A7 7 0 1 1 17 10A7 7 0 1 1 3 10ZM5 10A5 5 0 1 0 15 10A5 5 0 1 0 5 10ZM15.96 13.84L22.06 19.94L19.94 22.06L13.84 15.96Z",
      "evenOdd": false
    },
    {
      "key": "meeting",
      "ref": "lf:meeting",
      "name": "Meeting point",
      "group": "Story",
      "path": "M4.61 8.39A2.89 2.89 0 1 1 10.39 8.39A2.89 2.89 0 1 1 4.61 8.39ZM1.55 18.25L1.55 18.08L1.75 16.54L2.35 15.1L3.29 13.87L4.52 12.93L5.96 12.33L7.5 12.13L9.04 12.33L10.48 12.93L11.71 13.87L12.65 15.1L13.25 16.54L13.45 18.08L13.45 18.25ZM13.61 8.39A2.89 2.89 0 1 1 19.39 8.39A2.89 2.89 0 1 1 13.61 8.39ZM10.55 18.25L10.55 18.08L10.75 16.54L11.35 15.1L12.29 13.87L13.52 12.93L14.96 12.33L16.5 12.13L18.04 12.33L19.48 12.93L20.71 13.87L21.65 15.1L22.25 16.54L22.45 18.08L22.45 18.25Z",
      "evenOdd": false
    },
    {
      "key": "flag",
      "ref": "lf:flag",
      "name": "Flag",
      "group": "Story",
      "path": "M4.5 2.5L6.3 2.5L6.3 21.5L4.5 21.5ZM6.3 3.5L19.5 3.5L16 8L19.5 12.5L6.3 12.5Z",
      "evenOdd": false
    },
    {
      "key": "star",
      "ref": "lf:star",
      "name": "Star",
      "group": "Story",
      "path": "M12 2.3L14.53 9.32L21.99 9.56L16.09 14.13L18.17 21.29L12 17.1L5.83 21.29L7.91 14.13L2.01 9.56L9.47 9.32Z",
      "evenOdd": false
    },
    {
      "key": "scroll",
      "ref": "lf:scroll",
      "name": "Lore",
      "group": "Story",
      "path": "M6 4.5L18 4.5L18 19.5L6 19.5ZM3.8 6A2.2 2.2 0 1 1 8.2 6A2.2 2.2 0 1 1 3.8 6ZM15.8 18A2.2 2.2 0 1 1 20.2 18A2.2 2.2 0 1 1 15.8 18ZM8.5 9.1L15.5 9.1L15.5 8L8.5 8ZM8.5 12.1L15.5 12.1L15.5 11L8.5 11ZM8.5 15.1L13.5 15.1L13.5 14L8.5 14Z",
      "evenOdd": false
    },
    {
      "key": "home",
      "ref": "lf:home",
      "name": "Home base",
      "group": "Story",
      "path": "M2 12L12 3L22 12L19 12L19 21L5 21L5 12ZM11.12 13.79L8.67 13.92L10.57 15.46L9.94 17.83L12 16.5L14.06 17.83L13.43 15.46L15.33 13.92L12.88 13.79L12 11.5Z",
      "evenOdd": false
    },
    {
      "key": "hero",
      "ref": "lf:hero",
      "name": "Hero",
      "group": "Tokens",
      "path": "M6.43 7.07A3.57 3.57 0 1 1 13.57 7.07A3.57 3.57 0 1 1 6.43 7.07ZM2.65 19.25L2.65 19.04L2.9 17.14L3.63 15.36L4.8 13.84L6.32 12.67L8.1 11.94L10 11.69L11.9 11.94L13.68 12.67L15.2 13.84L16.37 15.36L17.1 17.14L17.35 19.04L17.35 19.25ZM20.3 3L20.3 17L18.7 17L18.7 3ZM17 13.8L22 13.8L22 15.2L17 15.2ZM18.9 16.9L20.1 16.9L20.1 20.4L18.9 20.4Z",
      "evenOdd": false
    },
    {
      "key": "soldier",
      "ref": "lf:soldier",
      "name": "Soldier",
      "group": "Tokens",
      "path": "M4 14L4 11L4.27 8.93L5.07 7L6.34 5.34L8 4.07L9.93 3.27L12 3L14.07 3.27L16 4.07L17.66 5.34L18.93 7L19.73 8.93L20 11L20 14ZM2 13L22 13L22 15.2L2 15.2ZM4 11L10.8 11L10.8 9L4 9ZM13.2 11L20 11L20 9L13.2 9ZM10.9 8L13.1 8L13.1 18.5L10.9 18.5ZM5 15.2L19 15.2L16.5 21L7.5 21Z",
      "evenOdd": false
    },
    {
      "key": "archer",
      "ref": "lf:archer",
      "name": "Archer",
      "group": "Tokens",
      "path": "M10.4 2.57L11.97 3.48L13.35 4.65L14.52 6.03L15.43 7.6L16.05 9.31L16.36 11.09L16.36 12.91L16.05 14.69L15.43 16.4L14.52 17.97L13.35 19.35L11.97 20.52L10.4 21.43L9.63 19.79L10.93 19.04L12.08 18.08L13.04 16.93L13.79 15.63L14.31 14.23L14.57 12.75L14.57 11.25L14.31 9.77L13.79 8.37L13.04 7.07L12.08 5.92L10.93 4.96L9.63 4.21ZM10.4 3.4L10.4 20.6L9.6 20.6L9.6 3.4ZM2 11.4L21 11.4L21 12.6L2 12.6ZM17.5 14.2L18.3 12L17.5 9.8L21 12ZM2.5 12L1 10L4.5 12L1 14Z",
      "evenOdd": false
    },
    {
      "key": "mage",
      "ref": "lf:mage",
      "name": "Mage",
      "group": "Tokens",
      "path": "M12 1.5L17.5 15L6.5 15ZM2.5 16.5A9.5 2.6 0 1 1 21.5 16.5A9.5 2.6 0 1 1 2.5 16.5ZM11.35 9.61L9.53 9.7L10.95 10.84L10.47 12.6L12 11.6L13.53 12.6L13.05 10.84L14.47 9.7L12.65 9.61L12 7.9Z",
      "evenOdd": false
    },
    {
      "key": "rogue",
      "ref": "lf:rogue",
      "name": "Rogue",
      "group": "Tokens",
      "path": "M12 2L19 8L20.5 21L3.5 21L5 8ZM8.2 11A3.8 4.4 0 1 0 15.8 11A3.8 4.4 0 1 0 8.2 11ZM9.6 11A0.9 0.9 0 1 1 11.4 11A0.9 0.9 0 1 1 9.6 11ZM12.6 11A0.9 0.9 0 1 1 14.4 11A0.9 0.9 0 1 1 12.6 11Z",
      "evenOdd": false
    },
    {
      "key": "beast",
      "ref": "lf:beast",
      "name": "Beast",
      "group": "Tokens",
      "path": "M6.5 16A5.5 4.5 0 1 1 17.5 16A5.5 4.5 0 1 1 6.5 16ZM3.1 10.5A2.1 2.8 0 1 1 7.3 10.5A2.1 2.8 0 1 1 3.1 10.5ZM7.3 6.5A2.1 2.8 0 1 1 11.5 6.5A2.1 2.8 0 1 1 7.3 6.5ZM12.5 6.5A2.1 2.8 0 1 1 16.7 6.5A2.1 2.8 0 1 1 12.5 6.5ZM16.7 10.5A2.1 2.8 0 1 1 20.9 10.5A2.1 2.8 0 1 1 16.7 10.5Z",
      "evenOdd": false
    },
    {
      "key": "dragon",
      "ref": "lf:dragon",
      "name": "Dragon",
      "group": "Tokens",
      "path": "M2 14L7 9L11 7.5L13.5 3L14.5 7L17 6.5L18.5 3.5L19 7.5L22 10.5L22 13.5L17.5 14L14 16L13.5 21L9.5 21L9.5 16L6 16.5ZM15.9 9.6A1.1 1.1 0 1 0 18.1 9.6A1.1 1.1 0 1 0 15.9 9.6ZM18.5 12.65L22 12.65L22 11.95L18.5 11.95Z",
      "evenOdd": false
    },
    {
      "key": "undead",
      "ref": "lf:undead",
      "name": "Undead",
      "group": "Tokens",
      "path": "M4 21L4 10L5.5 5.5L9 2.8L12 2.2L15 2.8L18.5 5.5L20 10L20 21L17.3 18.5L14.7 21L12 18.5L9.3 21L6.7 18.5ZM7.7 10A1.6 2.3 0 1 0 10.9 10A1.6 2.3 0 1 0 7.7 10ZM13.1 10A1.6 2.3 0 1 0 16.3 10A1.6 2.3 0 1 0 13.1 10ZM10.5 14.5A1.5 1.8 0 1 0 13.5 14.5A1.5 1.8 0 1 0 10.5 14.5Z",
      "evenOdd": false
    },
    {
      "key": "npc",
      "ref": "lf:npc",
      "name": "Person",
      "group": "Tokens",
      "path": "M8.09 6.91A3.91 3.91 0 1 1 15.91 6.91A3.91 3.91 0 1 1 8.09 6.91ZM3.95 20.25L3.95 20.02L4.22 17.94L5.03 15.99L6.31 14.33L7.97 13.05L9.92 12.24L12 11.97L14.08 12.24L16.02 13.05L17.69 14.33L18.97 15.99L19.78 17.94L20.05 20.02L20.05 20.25Z",
      "evenOdd": false
    },
    {
      "key": "party",
      "ref": "lf:party",
      "name": "Party",
      "group": "Tokens",
      "path": "M8.77 5.73A3.23 3.23 0 1 1 15.23 5.73A3.23 3.23 0 1 1 8.77 5.73ZM5.35 16.75L5.35 16.56L5.58 14.84L6.24 13.23L7.3 11.86L8.67 10.8L10.28 10.14L12 9.91L13.72 10.14L15.33 10.8L16.7 11.86L17.76 13.23L18.42 14.84L18.65 16.56L18.65 16.75ZM2.62 8.88A2.38 2.38 0 1 1 7.38 8.88A2.38 2.38 0 1 1 2.62 8.88ZM0.1 17L0.1 16.86L0.27 15.59L0.76 14.41L1.54 13.4L2.55 12.62L3.73 12.13L5 11.96L6.27 12.13L7.45 12.62L8.46 13.4L9.24 14.41L9.73 15.59L9.9 16.86L9.9 17ZM16.62 8.88A2.38 2.38 0 1 1 21.38 8.88A2.38 2.38 0 1 1 16.62 8.88ZM14.1 17L14.1 16.86L14.27 15.59L14.76 14.41L15.54 13.4L16.55 12.62L17.73 12.13L19 11.96L20.27 12.13L21.45 12.62L22.46 13.4L23.24 14.41L23.73 15.59L23.9 16.86L23.9 17Z",
      "evenOdd": false
    }
  ],
  "geometry": [
    {
      "stored": "0,0;100,0;100,50;0,50",
      "points": [
        [
          0.0,
          0.0
        ],
        [
          100.0,
          0.0
        ],
        [
          100.0,
          50.0
        ],
        [
          0.0,
          50.0
        ]
      ],
      "encoded": "0,0;100,0;100,50;0,50",
      "centroid": [
        50.0,
        25.0
      ],
      "area": 5000.0,
      "length": 250.0,
      "containsCentroid": true
    },
    {
      "stored": "10.5,20;300,40.25;150,260",
      "points": [
        [
          10.5,
          20.0
        ],
        [
          300.0,
          40.25
        ],
        [
          150.0,
          260.0
        ]
      ],
      "encoded": "10.50,20;300,40.25;150,260",
      "centroid": [
        153.5,
        106.75
      ],
      "area": 33327.5625,
      "length": 556.2713807608739,
      "containsCentroid": true
    },
    {
      "stored": "5,5;5,5;5,5",
      "points": [
        [
          5.0,
          5.0
        ],
        [
          5.0,
          5.0
        ],
        [
          5.0,
          5.0
        ]
      ],
      "encoded": "5,5;5,5;5,5",
      "centroid": [
        5.0,
        5.0
      ],
      "area": 0.0,
      "length": 0.0,
      "containsCentroid": false
    },
    {
      "stored": "0,0;40,0;40,40;20,10;0,40",
      "points": [
        [
          0.0,
          0.0
        ],
        [
          40.0,
          0.0
        ],
        [
          40.0,
          40.0
        ],
        [
          20.0,
          10.0
        ],
        [
          0.0,
          40.0
        ]
      ],
      "encoded": "0,0;40,0;40,40;20,10;0,40",
      "centroid": [
        20.0,
        14.0
      ],
      "area": 1000.0,
      "length": 152.11102550927978,
      "containsCentroid": false
    },
    {
      "stored": "1,2;bad;3,x;4,5;6,7",
      "points": [
        [
          1.0,
          2.0
        ],
        [
          4.0,
          5.0
        ],
        [
          6.0,
          7.0
        ]
      ],
      "encoded": "1,2;4,5;6,7",
      "centroid": [
        3.6666666666666665,
        4.666666666666667
      ],
      "area": 0.0,
      "length": 7.0710678118654755,
      "containsCentroid": false
    }
  ]
}
